// src/translations/en/shopPage.lang.en.js

const shopPageEN = {
	rating: {
		reviews: "{{count}} reviews",
	},
	searchServices: "Search services",
	main: {
		services: "Services",
		book: "Book",
		noServices: "No services listed yet.",
		reviews: "Reviews",
		noReviews: "No reviews yet",
		attributes: "Attributes",
		noAttributes: "No attributes yet",
		info: "Shop Info",
		about: "About",
		searchServices: "Search for a service"
		
	},
	sidebar: {
		description: "Description",
		location: "Location",
		information: "Information",
		staff: "Staff",
		contactAndHours: "Contact & Business Hours",
		noPhone: "No phone available",
		call: "Call",
		getDirections: "Get Directions",
		hours: {
			closed: "Closed",
		},
		socialTitle: "Social Media",
	},
};

export default shopPageEN;
